var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99796 1.3335C7.12249 1.3335 6.25558 1.50593 5.44674 1.84097C4.6379 2.176 3.90298 2.66706 3.28392 3.28612C2.03368 4.53636 1.3313 6.23205 1.3313 8.00016C1.3313 9.76827 2.03368 11.464 3.28392 12.7142C3.90298 13.3333 4.6379 13.8243 5.44674 14.1594C6.25558 14.4944 7.12249 14.6668 7.99796 14.6668C9.76608 14.6668 11.4618 13.9644 12.712 12.7142C13.9623 11.464 14.6646 9.76827 14.6646 8.00016H13.3313C13.3313 9.41465 12.7694 10.7712 11.7692 11.7714C10.769 12.7716 9.41245 13.3335 7.99796 13.3335C6.58348 13.3335 5.22692 12.7716 4.22673 11.7714C3.22654 10.7712 2.66463 9.41465 2.66463 8.00016C2.66463 6.58567 3.22654 5.22912 4.22673 4.22893C5.22692 3.22873 6.58348 2.66683 7.99796 2.66683V1.3335ZM12.518 2.00016C12.398 2.00118 12.2832 2.04902 12.198 2.1335L11.3846 2.94016L13.0513 4.60683L13.8646 3.80016C14.038 3.62683 14.038 3.3335 13.8646 3.16683L12.8313 2.1335C12.7446 2.04683 12.6313 2.00016 12.518 2.00016ZM10.9113 3.4135L5.99797 8.3335V10.0002H7.66463L12.578 5.08016L10.9113 3.4135Z",
    fill: "#2F2D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7291e73274ce0fbaedf45f9919623506.svg";
export { ForwardRef as ReactComponent };